export const PROJECT = {
  title: 'Telegram Cards',
  slug: 'telegram_cards',
  api_url: 'https://api.cs.wl.pintopay.tech',
  tma_domain: 'client.cs.wl.pintopay.tech',
  tg_bot_username: 'CryptoSpaceNetworkBot',
  passkeys_rp_name: 'Telegram Cards TMA',
} as const
